import dayjs from "@lib/dayjs"
import { JobStatus } from "@utils/constants"
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const JobCard = ({ data }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isClosed = data?.status === JobStatus.CLOSED && "Closed";
  const isExpired = data?.status === JobStatus.EXPIRED && "Expired";

  return (
    <NavLink
      to={`/job/${data?.hiringCompany?._id}/${data?._id}/applicant-list`}
      state={data}
      onClick={() => {
        //   dispatch(setJobDetail(data));
        // navigate(`/job/${data?._id}/applicants`, { state: data });
      }}
      className="grid grid-cols-[1fr_0.1fr] gap-16 items-center justify-between bg-white border-b border-[#ececec] rounded px-6 py-4 hover:bg-gray-50 cursor-pointer"
    >
      <div className="flex items-center gap-10">
        {/* Job details */}
        <div className="flex flex-col gap-2 w-[21rem]">
          <div className="flex items-center justify-between mb-1.5">
            <span className="text-xs text-primary font-medium">
              {data?.refNo}
            </span>
            <div className="flex items-center justify-center bg-gray-100 rounded-md py-2 px-5 text-xs font-medium text-primary">
              {data?.status === JobStatus.LIVE && "Live"}
              {data?.status === JobStatus.DRAFT && "Draft"}
              {data?.status === JobStatus.UNPUBLISHED && "Unpublished"}
              {data?.status === JobStatus.CLOSED && "Closed"}
              {data?.status === JobStatus.EXPIRED && "Expired"}
            </div>
          </div>
          <span className="text-sm font-semibold text-primary">
            {data?.title}
          </span>
          <div className="flex items-center gap-2">
            <span className="text-xss text-gray-400 font-medium">Hiring Company:</span>
            <span className="text-xss text-primary font-medium">{data?.hiringCompany?.companyName || "N/A"}</span>
          </div>
          <div className="flex items-center justify-between mt-2">
            <div className="flex items-center gap-2">
              <span className="text-xss text-gray-400 font-medium">
                Published:
              </span>
              <span className="text-xss text-primary italic font-medium">
                {data?.publishedDate &&
                  dayjs(data?.publishedDate).format("hh:mm a DD MMM YY")}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-xss text-gray-400 font-medium">
                {isClosed ? "Closed" : "Expiring"}:
              </span>
              <span className="text-xss text-primary italic font-medium">
                {dayjs(isClosed ? data?.updatedAt : data?.expiredAt).format(
                  "hh:mm a DD MMM YY"
                )}
              </span>
            </div>
          </div>
        </div>
        {/* Tracker details */}
        <div className="flex flex-col gap-1.5 flex-1 mt-2.5">
          <div className="flex items-center gap-3">
            <span className="text-xs text-primary font-medium italic">
              {dayjs(data?.latestTracker?.updatedAt).format("hh:mm a")}
            </span>
            <span className="text-xs text-primary font-medium italic">
              {dayjs(data?.latestTracker?.updatedAt).format("DD MMM YYYY")}
            </span>
          </div>
          <div className="flex flex-col border border-gray-200 bg-gray-50 rounded-md p-3 gap-1 h-[3.5rem] justify-center">
            <span className="text-xs font-medium text-primary">
              Latest Activity : {data?.latestTracker?.status || 'N/A'}
            </span>
          </div>
        </div>

      </div>
      <div className="flex flex-col items-center text-xs font-medium gap-2">
        Applicants
        <div className="relative w-16 h-16 flex items-center justify-center">
          {/* Glow layer */}
          {data?.unViewedApplicants ? (
            <span className="absolute inset-0 rounded-full bg-green-500 opacity-5 animate-pulse"></span>
          ) : null}

          {/* Badge */}
          <div
            className={`relative z-10 w-16 h-16 rounded-full border-2 border-custom-black flex items-center justify-center`}
          >
            <span className="text-sm font-semibold text-black">
              {data?.applicantCount}
            </span>
          </div>
        </div>

        {/* <div className="text-xs text-primary font-medium border-2 border-secondary rounded-full w-12 h-12 flex items-center justify-center relative golden-glow-bg">
            <span className="font-semibold">{data?.totalApplicants}</span>
          </div> */}
      </div>
    </NavLink>
  );
};


export default JobCard